import { AxiosResponse } from 'axios';

import { CounterOfferAcceptanceResponse } from '@proposal-configs/types';
import {
  HealthPolicyStatusResponse,
  SharePolicyDocumentResponse
} from '@store/health-status/types';

import { client } from '../client';

import { healthEndPoints } from './endpoints';

export const healthStatusAPIs = {
  getHealthStatus: (
    policyId: string
  ): Promise<AxiosResponse<HealthPolicyStatusResponse>> =>
    client.get(healthEndPoints.status(policyId)),
  sharePolicyDocument: (
    policyID: string,
    emails: string[]
  ): Promise<SharePolicyDocumentResponse> =>
    client.post(healthEndPoints.sharePolicyDocument(policyID), {
      email_ids: emails
    }),
  healthConfirmCounterOffer: (
    policyID: string
  ): Promise<AxiosResponse<CounterOfferAcceptanceResponse>> => {
    return client.post(healthEndPoints.confirmCounterOffer(policyID));
  }
};
